import axios from 'axios'
export default {
  namespaced: true,
  state() {
    return {
      room: null,
      history: null,
      room_online: null,
      record: null,
      token_record: null,
      current_date: null,
      loading: false,
      error: false,

    }
  },
  mutations: {
    set_loaded(state, v) { state.loading = v; },
    set_error(state, v) { state.error = v; },
    set_room(state, v) { state.room = v; },
    set_history(state, v) { state.history = v; },
    set_room_online(state, v) { state.room_online = v; },
    set_token_record(state, v) { state.token_record = v; },
    set_record(state, v) { state.record = v; },
    set_current_date(state, v) { state.current_date = v; },
    set_comment(state, v) { state.room_online.comments.push(v); }
  },
  actions: {  
    load(context) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);

      return axios.get('/1.0/online-interviews')
        .then(r => {
          context.commit('set_history', r.data.data);
          context.commit('set_loaded', false);
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          throw err;
        });
    },

    create(context, params) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);

      return axios.post('/1.0/online-interviews', params)
        .then(r => {
          context.commit('set_room', r.data.data[0]);
          context.commit('set_loaded', false);
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          throw err;
        });
    },

    get_record(context, id) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);

      return axios.get(`/1.0/online-interviews/${id}`)
        .then(r => {
          console.warn(r)
          context.commit('set_loaded', false);
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          throw err;
        });
    },

    create_link(context, id) {
      context.commit('set_error', null);

      return axios.post(`/1.0/online-interviews/${id}/link`)
        .then(r => {
          context.commit('set_token_record', r.data.data[0].token);
          context.commit('set_loaded', false);
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          throw err;
        });
    },

    open(context, token) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);

      return axios.get(`/1.0/public/online-interviews/${token}`)
        .then(r => {
          context.commit('set_record', r.data.data[0]);
          context.commit('set_loaded', false);
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          throw err;
        });
    },

    room(context, token) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);

      return axios.get(`/1.0/public/online-interviews/meeting/${token}`)
        .then(r => {
          context.commit('set_loaded', false);
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          throw err;
        });
    },

    join(context, options) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);

      let {value, token} = options;

      return axios.post(`/1.0/public/online-interviews/meeting/${token}/join`, {name: value})
        .then(r => {
          context.commit('set_room_online', r.data.data[0]);
          context.commit('set_loaded', false);
          return r.data.data[0];
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          throw err;
        });
    },

    start_record(context, options) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);

      let {token, hash} = options;

      return axios.post(`/1.0/online-interviews/meeting/${token}/${hash}/record`)
        .then(r => {
          context.commit('set_loaded', false);
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          throw err;
        });
    },

    stop_record(context, options) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);

      let {token, hash} = options;

      return axios.put(`/1.0/online-interviews/meeting/${token}/${hash}/record`)
        .then(r => {
          context.commit('set_loaded', false);
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          throw err;
        });
    },

    add_comment(context, options) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);

      let {token, body} = options;

      return axios.post(`/1.0/online-interviews/meeting/${token}/comment`, body)
        .then(r => {
          context.commit('set_comment', r.data.data[0]);
          context.commit('set_loaded', false);
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          throw err;
        });
    },

    update_comment(context, options) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);

      let {token, body} = options;

      return axios.put(`/1.0/online-interviews/meeting/${token}/comment`, body)
        .then(r => {
          context.commit('set_comment', r.data.data[0]);
          context.commit('set_loaded', false);
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          throw err;
        });
    },

    delete(context, options) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);
      console.warn('options', options)
      let {token, hash, id} = options;

      return axios.delete(`/1.0/online-interviews/meeting/${token}/${hash}/participant`, {data: {id_participant: id}} )
        .then(r => {
          console.warn(r)
          context.commit('set_loaded', false);
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          throw err;
        });
    },

    clear(context) {
      context.commit('set_room', null);
      context.commit('set_history', null);
    }
  },
  getters: {
    loading: state => state.loading,
    error: state => state.error,
    room: state => state.room,
    history: state => state.history,
    room_online: state => state.room_online,
    token_record: state => state.token_record,
    record: state => state.record,
    current_date: state => state.current_date
  }
}